<p>搭乗者情報入力テスト</p>

<button id="ssn-test-passenger-infomation-input-1" class="testButton" (click)="testButton1(false)">
  新規入力 入力済み
</button>
<button id="ssn-test-passenger-infomation-input-2" class="testButton" (click)="testButton1(true,-1)">
  編集モード 代表者
</button>
<button id="ssn-test-passenger-infomation-input-3" class="testButton" (click)="testButton1(true,0)">
  編集モード 1人目
</button>
<button id="ssn-test-passenger-infomation-input-4" class="testButton" (click)="testButton1(true,1)">
  編集モード 2人目
</button>
<button id="ssn-test-passenger-infomation-input-5" class="testButton" (click)="testButton1(true,-2)">
  編集モード 滞在中連絡先
</button>
<button id="ssn-test-passenger-infomation-input-6" class="testButton" (click)="testButton('1')">新規入力 未入力</button>
<button id="ssn-test-passenger-infomation-input-7" class="testButton" (click)="testButton2Edit(true,-1)">
  編集モード 未入力 代表者
</button>
<button id="ssn-test-passenger-infomation-input-8" class="testButton" (click)="testButton2Edit(true,0)">
  編集モード 未入力 1人目
</button>
<button id="ssn-test-passenger-infomation-input-9" class="testButton" (click)="testButton2Edit(true,1)">
  編集モード 未入力 2人目
</button>
<button id="ssn-test-passenger-infomation-input-10" class="testButton" (click)="testButton2Edit(true,-2)">
  編集モード 未入力 滞在中連絡先
</button>
<button id="ssn-test-passenger-infomation-input-11" class="testButton" (click)="testButton('2')">追加情報なし</button>
<button id="ssn-test-passenger-infomation-input-11-2" class="testButton" (click)="testButton('3')">国内旅程</button>
<button id="ssn-test-passenger-infomation-input-11-3" class="testButton" (click)="testButton('4')">電話番号系</button>
<button id="ssn-test-passenger-infomation-input-11-4" class="testButton" (click)="testButton('5')">電話番号系2</button>
<button id="ssn-test-passenger-infomation-input-11-5" class="testButton" (click)="testButton('6')">
  電話番号系 国内
</button>
<button id="ssn-test-passenger-infomation-input-11-6" class="testButton" (click)="testButton('7')">
  電話番号系2 国内
</button>
<button id="ssn-test-passenger-infomation-input-11-7" class="testButton" (click)="testButton('8')">
  電話番号系 連絡先未登録
</button>
<button id="ssn-test-passenger-infomation-input-11-8" class="testButton" (click)="testButton('9')">
  国内旅程 DCS以降
</button>
<button id="ssn-test-passenger-infomation-input-12" class="testButton" (click)="cartError('XXXXX')">
  カート取得エラー
</button>
<button id="ssn-test-passenger-infomation-input-13" class="testButton" (click)="updateError('EBAZ000301')">
  搭乗者更新エラーEBAZ000301
</button>
<button id="ssn-test-passenger-infomation-input-14" class="testButton" (click)="updateError('EBAZ000308')">
  搭乗者更新エラーEBAZ000308
</button>
<button id="ssn-test-passenger-infomation-input-15" class="testButton" (click)="updateError('EBAZ000307')">
  搭乗者更新エラーEBAZ000307
</button>
<button id="ssn-test-passenger-infomation-input-16" class="testButton" (click)="updateError('EBAZ000309')">
  搭乗者更新エラーEBAZ000309
</button>
<button id="ssn-test-passenger-infomation-input-17" class="testButton" (click)="updateError('EBAZ000302')">
  搭乗者更新エラーEBAZ000302
</button>
<button id="ssn-test-passenger-infomation-input-18" class="testButton" (click)="updateError('EBAZ000157')">
  搭乗者更新エラーEBAZ000157
</button>
<button id="ssn-test-passenger-infomation-input-prebook1" class="testButton" (click)="prebookError('EBAZ000278')">
  prebookエラーEBAZ000278
</button>
<button id="ssn-test-passenger-infomation-input-prebook2" class="testButton" (click)="prebookError('EBAZ000219')">
  prebookエラーEBAZ000219
</button>
<p>設定値</p>
<div class="testTitle">
  <button id="ssn-test-passenger-infomation-input-101" class="testButton" (click)="posChange('CA')">
    POSをカナダにする
  </button>
  <button id="ssn-test-passenger-infomation-input-102" class="testButton" (click)="posChange('JP')">
    POSを日本にする
  </button>
  <button id="ssn-test-passenger-infomation-input-103" class="testButton" (click)="officeChange('FRANH08AA','DE')">
    オフィスをドイツにする
  </button>
  <button id="ssn-test-passenger-infomation-input-104" class="testButton" (click)="officeChange('VIENH08AA','AT')">
    オフィスをオーストラリアにする
  </button>
  <button id="ssn-test-passenger-infomation-input-105" class="testButton" (click)="officeChange('TYONH08AA','JP')">
    オフィスを日本にする
  </button>
  <button id="ssn-test-passenger-infomation-input-106" class="testButton" (click)="langChange('de')">
    LANGをドイツ語にする
  </button>
  <button id="ssn-test-passenger-infomation-input-107" class="testButton" (click)="langChange('ja')">
    LANGを日本語にする
  </button>
  <button id="ssn-test-passenger-infomation-input-108" class="testButton" (click)="langChange('en')">
    LANGを英語にする
  </button>
</div>

<p>遷移先分岐モーダル</p>
<div class="testTitle">
  <button id="ssn-test-passenger-infomation-input-21" class="testButton" (click)="senisaki1()">正常</button>
  <button id="ssn-test-passenger-infomation-input-121" class="testButton" (click)="senisakiNotU12AndU4()">
    12歳以上なし4歳以下あり
  </button>
  <button id="ssn-test-passenger-infomation-input-122" class="testButton" (click)="senisakiU12AndU4()">
    12歳以上あり4歳以下あり
  </button>
  <button id="ssn-test-passenger-infomation-input-123" class="testButton" (click)="senisakiNotU12AndNotU4()">
    12歳以上なし4歳以下なし
  </button>
  <button id="ssn-test-passenger-infomation-input-124" class="testButton" (click)="senisakiNotU12AndU4Pnr()">
    12歳以上なし4歳以下あり他PNRtrue
  </button>
  <button id="ssn-test-passenger-infomation-input-125" class="testButton" (click)="senisakiAllChd()">子供のみ</button>
  <button id="ssn-test-passenger-infomation-input-126" class="testButton" (click)="senisakiAllChdAndAdt()">
    子供と大人
  </button>
  <button id="ssn-test-passenger-infomation-input-127" class="testButton" (click)="senisakiAllChdPnr()">
    子供のみ他PNRtrue
  </button>
  <button id="ssn-test-passenger-infomation-input-128" class="testButton" (click)="senisakiDisAbilityDuplicate()">
    障がい者重複
  </button>
  <button id="ssn-test-passenger-infomation-input-129" class="testButton" (click)="senisakiDisAbilitySuccess()">
    障がい者重複無し
  </button>

  <button id="ssn-test-passenger-infomation-input-22" class="testButton" (click)="senisaki1NoMiddle()">
    ミドルネームなし
  </button>
  <button id="ssn-test-passenger-infomation-input-23" class="testButton" (click)="senisaki1U21()">全員20歳以下</button>
  <button id="ssn-test-passenger-infomation-input-24" class="testButton" (click)="senisaki1U21Equal()">21歳含む</button>
  <button id="ssn-test-passenger-infomation-input-25" class="testButton" (click)="senisaki1U21EqualDep()">
    出発日に21歳
  </button>
  <button id="ssn-test-passenger-infomation-input-51" class="testButton" (click)="senisaki1U21Nh()">
    全員20歳以下 NH便
  </button>
  <button id="ssn-test-passenger-infomation-input-26" class="testButton" (click)="senisaki2()">出発地メキシコ</button>
  <button id="ssn-test-passenger-infomation-input-27" class="testButton" (click)="senisaki2U18()">
    出発地メキシコ18歳以下を含む
  </button>
  <button id="ssn-test-passenger-infomation-input-28" class="testButton" (click)="senisaki2U18Equal()">
    出発地メキシコ18歳を含む
  </button>
  <button id="ssn-test-passenger-infomation-input-29" class="testButton" (click)="senisaki2U18EqualDep()">
    出発地メキシコ出発日に18歳
  </button>
  <button id="ssn-test-passenger-infomation-input-30" class="testButton" (click)="senisaki2U18EqualDep2()">
    出発地メキシコ到着日に18歳
  </button>
  <button id="ssn-test-passenger-infomation-input-31" class="testButton" (click)="senisaki3()">到着地メキシコ</button>
  <button id="ssn-test-passenger-infomation-input-32" class="testButton" (click)="senisaki3U18()">
    到着地メキシコ18歳以下を含む
  </button>
  <button id="ssn-test-passenger-infomation-input-33" class="testButton" (click)="senisaki3U18Equal()">
    到着地メキシコ18歳を含む
  </button>
  <button id="ssn-test-passenger-infomation-input-34" class="testButton" (click)="senisaki3U18EqualDep()">
    到着地メキシコ出発日に18歳
  </button>
  <button id="ssn-test-passenger-infomation-input-35" class="testButton" (click)="senisaki3U18EqualDep2()">
    到着地メキシコ到着日に18歳
  </button>
  <button id="ssn-test-passenger-infomation-input-36" class="testButton" (click)="senisakiApiError('EBAZ000299')">
    prebookエラーEBAZ000299
  </button>
  <button id="ssn-test-passenger-infomation-input-37" class="testButton" (click)="senisakiApiError('EBAZ000427')">
    prebookエラーEBAZ000427
  </button>
  <button id="ssn-test-passenger-infomation-input-38" class="testButton" (click)="senisakiApiError('EBAZ000308')">
    prebookエラーEBAZ000308
  </button>
  <button id="ssn-test-passenger-infomation-input-151" class="testButton" (click)="senisakiApiError('EBAZ000545')">
    prebookエラーEBAZ000545
  </button>
  <button id="ssn-test-passenger-infomation-input-152" class="testButton" (click)="senisakiApiError('EBAZ000546')">
    prebookエラーEBAZ000546
  </button>
  <button id="ssn-test-passenger-infomation-input-153" class="testButton" (click)="senisakiApiError('EBAZ000547')">
    prebookエラーEBAZ000547
  </button>
  <button id="ssn-test-passenger-infomation-input-154" class="testButton" (click)="senisakiApiError('EBAZ000549')">
    prebookエラーEBAZ000549
  </button>
  <button id="ssn-test-passenger-infomation-input-155" class="testButton" (click)="senisakiApiError('EBAZ000548')">
    prebookエラーEBAZ000548
  </button>
  <button id="ssn-test-passenger-infomation-input-39" class="testButton" (click)="senisakiApiError('EBAZ000428')">
    prebookエラーEBAZ000428
  </button>
  <button id="ssn-test-passenger-infomation-input-40" class="testButton" (click)="senisakiApiError('EBAZ000265')">
    prebookエラーEBAZ000265
  </button>
  <button id="ssn-test-passenger-infomation-input-41" class="testButton" (click)="senisakiApiError('EBAZ000429')">
    prebookエラーEBAZ000429
  </button>
  <button id="ssn-test-passenger-infomation-input-42" class="testButton" (click)="senisakiApiError('EBAZ000412')">
    prebookエラーEBAZ000412
  </button>
  <button id="ssn-test-passenger-infomation-input-43" class="testButton" (click)="senisakiApiError('EBAZ000479')">
    prebookエラーEBAZ000479
  </button>
  <button id="ssn-test-passenger-infomation-input-156" class="testButton" (click)="senisakiApiError('EBAZ000551')">
    prebookエラーEBAZ000551
  </button>
  <button id="ssn-test-passenger-infomation-input-44" class="testButton" (click)="senisakiApiError('EBAZ000431')">
    prebookエラーEBAZ000431
  </button>
  <button id="ssn-test-passenger-infomation-input-45" class="testButton" (click)="senisakiApiError('EBAZ000432')">
    prebookエラーEBAZ000432
  </button>
  <button id="ssn-test-passenger-infomation-input-46" class="testButton" (click)="senisakiApiError('EBAZ000479')">
    prebookエラーEBAZ000479
  </button>
  <button id="ssn-test-passenger-infomation-input-201" class="testButton" (click)="senisakiApiError('EBAZ000529')">
    prebookエラーEBAZ000529
  </button>
  <button id="ssn-test-passenger-infomation-input-202" class="testButton" (click)="senisakiApiError('EBAZ000530')">
    prebookエラーEBAZ000530
  </button>
  <button id="ssn-test-passenger-infomation-input-203" class="testButton" (click)="senisakiApiError('EBAZ000695')">
    prebookエラーEBAZ000695
  </button>
  <button id="ssn-test-passenger-infomation-input-47" class="testButton" (click)="senisakiApiError('EBAZ000278')">
    prebookエラーEBAZ000278
  </button>
  <button id="ssn-test-passenger-infomation-input-48" class="testButton" (click)="senisakiApiError('EBAZ000422')">
    prebookエラーEBAZ000422
  </button>
  <button id="ssn-test-passenger-infomation-input-157" class="testButton" (click)="senisakiApiError('EBAZ000543')">
    prebookエラーEBAZ000543
  </button>
  <button id="ssn-test-passenger-infomation-input-158" class="testButton" (click)="senisakiApiError('WBAZ000522')">
    prebookエラーWBAZ000522
  </button>
  <button id="ssn-test-passenger-infomation-input-49" class="testButton" (click)="senisakiApiError('XXXXX')">
    prebookエラーXXXXX
  </button>
  <button id="ssn-test-passenger-infomation-input-50" class="testButton" (click)="senisakiPnrError()">PNRエラー</button>
</div>
